import React, { useState } from "react";
import locale from "@bonliva-crm/locale";
import { PrimaryButton, RegularButton, TopBarProps } from "@components";
import FormControls from "@components/forms/common/FormControls";
import { TabContainer, TabContainerProps } from "@components/TabContainer";
import { TabProps } from "@components/Tabs";
import WithRouteBlock from "@components/forms/WithRouteBlock";
import EditPageLayout from "@components/layouts/EditPageLayout";
import { useLegacyNavigation } from "@navigation";
import { PaperProps } from "@material-ui/core/Paper";

type Props = {
  beforeContent?: React.ReactNode;
  blockId: string;
  canSubmit: boolean;
  children?: React.ReactNode;
  extraButtons?: React.ReactNode;
  hideButtons?: boolean;
  isDirty: boolean;
  isSubmitting: boolean;
  onClose?: () => void;
  onReset?: (e?: any) => void;
  onSubmit?: () => void;
  tabs: TabProps[];
  topbarProps?: Partial<TopBarProps>;
  PaperProps?: Partial<PaperProps>;
  tabContainerProps?: Partial<TabContainerProps>;
};

export const TabFormLayout = (props: Props) => {
  const navigation = useLegacyNavigation();
  const [isLockNavigation, setIsLockNavigation] = useState(true);

  if (navigation && props.blockId && isLockNavigation) {
    navigation.lockNavigation(props.blockId, props.isDirty, locale.priceLeaveNow);
  } else {
    navigation.unBlock(props.blockId);
  }

  const onSubmit = () => {
    setIsLockNavigation(false);
    props.onSubmit();
  };

  const tabContainer = (
    <TabContainer
      beforeContent={props.beforeContent}
      tabs={props.tabs}
      AppBarProps={{ elevation: 0 }}
      ContentProps={{ style: { flex: 1 } }}
      PaperProps={{
        elevation: 0,
        style: { display: "flex", flexWrap: "wrap" },
        ...props.PaperProps
      }}
      TabsProps={{
        variant: "scrollable",
        scrollButtons: "auto",
        style: { flex: 1 }
      }}
      withPadding
    >
      {({ nextBtn, prevBtn, tabs }) => (
        <>
          {tabs}

          <FormControls
            left={
              <>
                {prevBtn}
                {nextBtn}
              </>
            }
            right={
              <>
                {props.extraButtons}

                {!props.hideButtons && (
                  <RegularButton onClick={props.onClose}>{locale.Cancel}</RegularButton>
                )}

                {!props.hideButtons && (
                  <PrimaryButton
                    type={props.onSubmit ? "button" : "submit"}
                    onClick={() => onSubmit()}
                    disabled={!props.canSubmit}
                    loading={props.isSubmitting}
                  >
                    {locale.Save}
                  </PrimaryButton>
                )}
              </>
            }
          />
        </>
      )}
    </TabContainer>
  );

  let content = props.children;

  if (props.blockId && !navigation) {
    content = (
      <WithRouteBlock
        blockId={props.blockId}
        message={locale.priceLeaveNow}
        dirty={props.isDirty}
        ignoreHashChanges
      >
        {content}
      </WithRouteBlock>
    );
  }

  return (
    <EditPageLayout fitted topbarProps={props.topbarProps}>
      {tabContainer}
      {content}
    </EditPageLayout>
  );
};
